import {NavLink} from "react-router-dom";


export default function BreadCrumbs(props: any) {

    const {user, itemsLinks} = props

    const path = itemsLinks.map((item: any, index: any) => {

        return (
            <div key={index}>
                {index === itemsLinks.length - 1 ?
                    <span style={{color: "#666666"}}>{item.name}</span>
                    :
                    <div>
                        <NavLink to={item.link}>{item.name}</NavLink><span>&nbsp;&gt;&nbsp;</span>
                    </div>
                }
            </div>
        )
    })

    return (
        <div className="breadcrumbs">
            <div style={{display: 'flex'}}>
                {path}
            </div>

            {/*<div>Main :: Applications</div>*/}
            {user && <div style={{color: '#737373'}}>User: {user.username}</div>}
        </div>

    )
}